import React, { useEffect, useState } from "react";

export default function MessageBeacon({ onClick, docked }) {
  const [glitch, setGlitch] = useState(false);
  const [glitchPhase, setGlitchPhase] = useState(0);

  useEffect(() => {
    if (docked) return;
    const schedule = () => {
      const delay = 1500 + Math.random() * 1500;
      return setTimeout(() => {
        const bursts = 2 + Math.floor(Math.random() * 2);
        let i = 0;
        const burst = () => {
          setGlitch(true);
          setGlitchPhase(Math.floor(Math.random() * 3));
          setTimeout(() => {
            setGlitch(false);
            i++;
            if (i < bursts) setTimeout(burst, 80 + Math.random() * 60);
          }, 60 + Math.random() * 80);
        };
        burst();
        timerRef.current = schedule();
      }, delay);
    };
    const timerRef = { current: schedule() };
    return () => clearTimeout(timerRef.current);
  }, [docked]);

  if (!docked) {
    const glitchFilter = glitch
      ? glitchPhase === 0
        ? "drop-shadow(3px 0 0 rgba(239,68,68,1)) drop-shadow(-3px 0 0 rgba(6,182,212,1)) drop-shadow(0 0 12px rgba(239,68,68,0.6))"
        : glitchPhase === 1
        ? "drop-shadow(-4px 1px 0 rgba(168,85,247,1)) drop-shadow(4px -1px 0 rgba(52,211,153,1))"
        : "drop-shadow(2px -2px 0 rgba(251,191,36,1)) drop-shadow(-2px 2px 0 rgba(239,68,68,1))"
      : "drop-shadow(0 0 14px rgba(99,102,241,0.8)) drop-shadow(0 0 4px rgba(165,180,252,0.4))";

    return (
      <div className="flex flex-col items-center gap-8 select-none">

        {/* Label supérieur */}
        <div style={{
          fontFamily: "ui-monospace, 'SF Mono', monospace",
          fontSize: 12,
          letterSpacing: "0.35em",
          textTransform: "uppercase",
          color: glitch ? "rgba(239,68,68,0.9)" : "rgba(99,102,241,0.75)",
          display: "flex",
          alignItems: "center",
          gap: 12,
          transition: "color 0.05s",
        }}>
          <span style={{ width: 32, height: 1, background: glitch ? "rgba(239,68,68,0.6)" : "rgba(99,102,241,0.5)", display: "inline-block", transition: "background 0.05s" }} />
          TRANSMISSION ENTRANTE
          <span style={{ width: 32, height: 1, background: glitch ? "rgba(239,68,68,0.6)" : "rgba(99,102,241,0.5)", display: "inline-block", transition: "background 0.05s" }} />
        </div>

        {/* Bouton principal */}
        <button
          onClick={onClick}
          style={{
            position: "relative",
            width: 160,
            height: 160,
            borderRadius: "50%",
            background: glitch
              ? "radial-gradient(circle at 35% 35%, rgba(239,68,68,0.15) 0%, rgba(6,8,30,0.98) 70%)"
              : "radial-gradient(circle at 35% 35%, rgba(99,102,241,0.3) 0%, rgba(6,8,30,0.98) 65%)",
            border: glitch
              ? "1.5px solid rgba(239,68,68,0.8)"
              : "1.5px solid rgba(99,102,241,0.7)",
            boxShadow: glitch
              ? "0 0 0 10px rgba(239,68,68,0.05), 0 0 60px rgba(239,68,68,0.3), inset 0 0 40px rgba(239,68,68,0.08)"
              : "0 0 0 10px rgba(99,102,241,0.07), 0 0 60px rgba(99,102,241,0.25), inset 0 0 40px rgba(99,102,241,0.1)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 8,
            transition: "box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease, transform 0.2s ease",
            outline: "none",
            overflow: "visible",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = "0 0 0 14px rgba(99,102,241,0.12), 0 0 80px rgba(99,102,241,0.4), inset 0 0 40px rgba(99,102,241,0.15)";
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.borderColor = "rgba(165,180,252,0.9)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = "0 0 0 10px rgba(99,102,241,0.07), 0 0 60px rgba(99,102,241,0.25), inset 0 0 40px rgba(99,102,241,0.1)";
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.borderColor = "rgba(99,102,241,0.7)";
          }}
        >
          {/* Anneaux animés */}
          {[0, 0.9, 1.8].map((delay, i) => (
            <span key={i} style={{
              position: "absolute",
              inset: -20,
              borderRadius: "50%",
              border: `1px solid rgba(99,102,241,${0.25 - i * 0.07})`,
              animation: `beacon-ring 2.2s ease-out infinite ${delay}s`,
              pointerEvents: "none",
            }} />
          ))}

          {/* Scan line */}
          <span style={{
            position: "absolute",
            left: 0, right: 0,
            height: 1,
            background: "linear-gradient(90deg, transparent, rgba(99,102,241,0.6), transparent)",
            animation: "beacon-scan 2.8s linear infinite",
            pointerEvents: "none",
          }} />

          {/* Icône enveloppe */}
          <svg width="52" height="52" viewBox="0 0 36 36" fill="none"
            style={{ filter: glitchFilter, transition: "filter 0.04s" }}
          >
            <rect x="3" y="8" width="30" height="20" rx="2"
              stroke={glitch ? "rgba(239,68,68,0.95)" : "rgba(165,180,252,0.95)"}
              strokeWidth="1.5" fill="none" />
            <path d="M3 10l15 11L33 10"
              stroke={glitch ? "rgba(239,68,68,0.95)" : "rgba(165,180,252,0.95)"}
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          </svg>

          {/* Label OUVRIR */}
          <span style={{
            fontFamily: "ui-monospace, 'SF Mono', monospace",
            fontSize: 10,
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            color: glitch ? "rgba(239,68,68,0.95)" : "rgba(165,180,252,0.85)",
            transition: "color 0.04s",
            position: "relative",
            userSelect: "none",
          }}>
            {glitch ? (
              <span style={{ position: "relative", display: "inline-block" }}>
                <span style={{ position: "absolute", left: 3, top: 0, color: "rgba(6,182,212,0.9)", pointerEvents: "none" }}>OUVRIR</span>
                <span style={{ position: "absolute", left: -3, top: 0, color: "rgba(239,68,68,0.9)", pointerEvents: "none" }}>OUVRIR</span>
                OUVRIR
              </span>
            ) : "OUVRIR"}
          </span>

          {/* Point vert */}
          <span style={{
            position: "absolute",
            top: 18, right: 18,
            width: 10, height: 10,
            borderRadius: "50%",
            background: "rgba(52,211,153,1)",
            boxShadow: "0 0 12px rgba(52,211,153,0.9), 0 0 4px rgba(52,211,153,1)",
            animation: "beacon-dot 1.4s ease-in-out infinite",
          }} />

          {/* Coins déco */}
          {[
            { top: 10, left: 10, bt: true, bl: true },
            { top: 10, right: 10, bt: true, br: true },
            { bottom: 10, left: 10, bb: true, bl: true },
            { bottom: 10, right: 10, bb: true, br: true },
          ].map((c, i) => (
            <span key={i} style={{
              position: "absolute",
              top: c.top, right: c.right, bottom: c.bottom, left: c.left,
              width: 10, height: 10,
              borderTop: c.bt ? "1px solid rgba(99,102,241,0.6)" : "none",
              borderBottom: c.bb ? "1px solid rgba(99,102,241,0.6)" : "none",
              borderLeft: c.bl ? "1px solid rgba(99,102,241,0.6)" : "none",
              borderRight: c.br ? "1px solid rgba(99,102,241,0.6)" : "none",
              pointerEvents: "none",
            }} />
          ))}
        </button>

        {/* Labels inférieurs */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
          <span style={{
            fontFamily: "ui-monospace, 'SF Mono', monospace",
            fontSize: 13,
            color: "rgba(203,213,225,0.9)",
            letterSpacing: "0.04em",
          }}>
            Cliquez pour lire votre brief de mission
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 4, height: 4, borderRadius: "50%", background: "rgba(239,68,68,0.8)", display: "inline-block", animation: "beacon-dot 1.4s ease-in-out infinite 0.2s" }} />
            <span style={{
              fontFamily: "ui-monospace, 'SF Mono', monospace",
              fontSize: 11,
              color: "rgba(239,68,68,0.7)",
              letterSpacing: "0.2em",
              textTransform: "uppercase",
            }}>
              Priorité : élevée
            </span>
            <span style={{ width: 4, height: 4, borderRadius: "50%", background: "rgba(239,68,68,0.8)", display: "inline-block", animation: "beacon-dot 1.4s ease-in-out infinite 0.4s" }} />
          </div>
        </div>

        <style>{`
          @keyframes beacon-ring {
            0% { transform: scale(1); opacity: 0.9; }
            100% { transform: scale(1.6); opacity: 0; }
          }
          @keyframes beacon-dot {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.2; }
          }
          @keyframes beacon-scan {
            0% { top: 15%; opacity: 0; }
            10% { opacity: 1; }
            90% { opacity: 1; }
            100% { top: 85%; opacity: 0; }
          }
        `}</style>
      </div>
    );
  }

  // Version dockée
  return (
    <button
      onClick={onClick}
      style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "6px 14px", borderRadius: 999,
        background: "rgba(6,8,30,0.9)",
        border: "1px solid rgba(99,102,241,0.4)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 0 14px rgba(99,102,241,0.12)",
        cursor: "pointer",
        fontFamily: "ui-monospace, 'SF Mono', monospace",
        fontSize: 10, fontWeight: 700,
        letterSpacing: "0.15em", textTransform: "uppercase",
        color: "rgba(165,180,252,0.9)",
        transition: "box-shadow 0.2s, border-color 0.2s",
        outline: "none",
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(99,102,241,0.7)"; e.currentTarget.style.boxShadow = "0 0 20px rgba(99,102,241,0.2)"; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(99,102,241,0.4)"; e.currentTarget.style.boxShadow = "0 0 14px rgba(99,102,241,0.12)"; }}
    >
      <span style={{ position: "relative", display: "inline-flex", width: 8, height: 8 }}>
        <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "rgba(52,211,153,1)", animation: "beacon-dot 1.6s ease-in-out infinite" }} />
        <span style={{ position: "absolute", inset: -3, borderRadius: "50%", border: "1px solid rgba(52,211,153,0.4)", animation: "beacon-ring-sm 1.8s ease-out infinite" }} />
      </span>
      <span>Brief</span>
      <style>{`
        @keyframes beacon-dot { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
        @keyframes beacon-ring-sm { 0% { transform: scale(1); opacity: 0.6; } 100% { transform: scale(1.8); opacity: 0; } }
      `}</style>
    </button>
  );
}